import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setPage,
  setMaxPages,
  setSorting,
  setActiveDocumentsTab,
  setSearch,
  setSearchValue,
  setCategory,
  setStatus,
  setTotalCount,
  setCheckedItems,
} from '../../store/documentsTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  leftSideConfig,
  rightSideConfig,
  categoryFilterOptions,
  statusFilterOptions,
  empty,
} from './documentsTableConfig.js';
import { fetchDocuments } from './documentsTableService.js';
import Table from '../../components/list2/table';
import Pagination from '../../components/components/pagination/pagination.jsx';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';
import UniversalLineWithComponents from '../../components/components/universal_line_with_components/universalLineWithComponents.jsx';
import './Documents.css';

function Documents() {
  const dispatch = useDispatch();
  const activeDocumentsTab = useSelector((state) => state.documents.activeDocumentsTab);
  const totalPages = useSelector((state) => state.documents.maxPages);
  const currentPage = useSelector((state) => state.documents.currentPage);
  const sortBy = useSelector((state) => state.documents.sortBy);
  const sortDirection = useSelector((state) => state.documents.sortDirection);
  const checkedItems = useSelector((state) => state.documents.checkedItems);
  const search = useSelector((state) => state.documents.search);
  const searchValue = useSelector((state) => state.documents.searchValue);
  const category = useSelector((state) => state.documents.category);
  const status = useSelector((state) => state.documents.status);
  const userId = useSelector((state) => state.documents.userId);
  const createdFrom = useSelector((state) => state.documents.createdFrom);
  const createdTo = useSelector((state) => state.documents.createdTo);
  const totalCount = useSelector((state) => state.documents.totalCount);

  const [rows, setRows] = useState([]);
  const [documentsData, setDocumentsData] = useState([]);
  const sortArrowColorActive = '#FFFFFF';
  const sortArrowColorInactive = 'rgba(255,255,255,0.45)';

  useEffect(() => {
    fetchDocuments(
      sortBy,
      sortDirection,
      currentPage,
      dispatch,
      setMaxPages,
      setRows,
      setTotalCount,
      setDocumentsData,
      checkedItems,
      search,
      category,
      status,
      userId,
      createdFrom,
      createdTo
    );
  }, [
    currentPage,
    sortBy,
    sortDirection,
    checkedItems,
    search,
    category,
    status,
    userId,
    createdFrom,
    createdTo,
  ]);

  const headers = getHeaders(
    sortBy,
    sortDirection,
    dispatch,
    setSorting,
    sortArrowColorActive,
    sortArrowColorInactive,
    rows,
    checkedItems,
    documentsData,
    setCheckedItems
  );

  const paginationProps = {
    reduxSelector: (state) => state.documents.currentPage,
    reduxAction: setPage,
    totalPages: totalPages,
    maxVisibleButtons: 5,
  };

  const rightSideConfig2 = [
    {
      component: Pagination,
      props: paginationProps,
    },
  ];

  // Create fetch params for delete action
  const fetchParams = [
    sortBy,
    sortDirection,
    currentPage,
    dispatch,
    setMaxPages,
    setRows,
    setTotalCount,
    setDocumentsData,
    checkedItems,
    search,
    category,
    status,
    userId,
    createdFrom,
    createdTo,
  ];

  return (
    <div>
      <Menu />
      <Content>
        <LineWithButtons
          tabs={tabsConfig(activeDocumentsTab, dispatch, setActiveDocumentsTab)}
          buttons={buttonsConfig}
          rightSide={rightSideConfig(searchValue, dispatch)}
        />
        <div className="documents-info">
          <span className="documents-count">Wyszukano: {totalCount} wyników</span>
        </div>
        <div className="documents-filters">
          <div className="filter-group">
            <select
              className="filter-select"
              value={status || ''}
              onChange={(e) => {
                dispatch(setStatus(e.target.value || null));
              }}
            >
              {statusFilterOptions.map((option) => (
                <option key={option.value || 'empty'} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-group">
            <select
              className="filter-select"
              value={category || ''}
              onChange={(e) => {
                dispatch(setCategory(e.target.value || null));
              }}
            >
              {categoryFilterOptions.map((option) => (
                <option key={option.value || 'empty'} value={option.value || ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="table-container">
          <Table
            headers={headers}
            rows={rows}
            columnWidths={headerWidths}
            idViewing={false}
            idArrayId={1}
            cellClass2="cell-center"
            cellClass2ConditionList={[4, 5, 6, 7]}
          />
          <UniversalLineWithComponents
            leftSide={leftSideConfig(checkedItems, dispatch, fetchDocuments, ...fetchParams)}
            rightSide={rightSideConfig2}
          />
        </div>
      </Content>
    </div>
  );
}

export default Documents;

